export default __webpack_public_path__ + "static/media/1.bb2d3c6b.jpg";